import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalVariables } from '../../../global-variables';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private url = GlobalVariables.appURL;
  constructor(private _httpClient: HttpClient) { }


  public detail(id: any): Observable<any> {
    return this._httpClient.get(this.url + 'users/' + id);
  }
  public links(id: any): Observable<any> {
    return this._httpClient.get(this.url + 'users/links/' + id);
  }
  public profile_update(data: any): Observable<any> {
    return this._httpClient.patch(this.url + 'customers/profile/' + data.id, data);
  }

  public profile_change_password(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'users/profile-change-password/', data);
  }

  public get_business_user_name(organizationId): Observable<any> {
    return this._httpClient.get(`${this.url}business-users/${organizationId}/name`);
  }

  public get_store_user_name(storeId): Observable<any> {
    return this._httpClient.get(this.url + 'stores/storelogo/' + storeId);
  }

  public get_store_owner_logo(storeId): Observable<any> {
    return this._httpClient.get(this.url + 'stores/owner/logo/' + storeId);
  }

  public profile_photo(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'users/profile-photo', data);
  }

   public profile_cover(id): Observable<any> {
    return this._httpClient.get(`${this.url}business-users/${id}/name`);
  }

  public getOrgIdBySlug(slug: string): Observable<any> {
    return this._httpClient.get(`${this.url}org-users/${slug}/id`);
  }


  public getBanners(): Observable<any> {
    return this._httpClient.get(this.url + 'banners'); 
  }

  public getBannerID(id: any): Observable<any> {
    return this._httpClient.get(this.url + 'banners/' + id); 
  }

  public getBannersByCreator(id: string): Observable<any> {
  return this._httpClient.get(this.url + 'banners/' + id); 
}


  public getUser(id: string): Observable<any> {
    return this._httpClient.get(`${this.url}users/${id}`);
  }
  
}

